<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
  >
    <g clip-path="url(#clip0_622_2424)">
      <path
        d="M28.3454 1.89683C27.4269 1.06984 26.2177 0.641222 24.9835 0.705905L7.00819 1.64795C5.77397 1.71263 4.61621 2.2653 3.78923 3.18376C2.96225 4.10222 2.53363 5.3114 2.59831 6.54562L3.7497 28.5155C3.81438 29.7497 4.36705 30.9074 5.28551 31.7344C6.20397 32.5614 7.41315 32.99 8.64736 32.9253L26.6227 31.9833C27.8569 31.9186 29.0147 31.3659 29.8417 30.4475C30.6686 29.529 31.0973 28.3198 31.0326 27.0856L29.8812 5.11578C29.8165 3.88156 29.2638 2.72381 28.3454 1.89683Z"
        fill="white"
      />
      <path
        d="M25.1228 3.36222L7.14742 4.30426C6.61771 4.33202 6.12073 4.56907 5.7658 4.96326C5.41087 5.35745 5.22707 5.87649 5.25483 6.40619L6.40622 28.376C6.43399 28.9058 6.67103 29.4027 7.06522 29.7577C7.45941 30.1126 7.97845 30.2964 8.50816 30.2686L26.4835 29.3266C27.0132 29.2988 27.5102 29.0618 27.8651 28.6676C28.22 28.2734 28.4038 27.7544 28.3761 27.2247L27.2247 5.2548C27.1969 4.7251 26.9599 4.22811 26.5657 3.87319C26.1715 3.51826 25.6525 3.33446 25.1228 3.36222ZM17.914 18.6705L17.9188 18.7603C17.9326 19.0252 17.8407 19.2847 17.6633 19.4818C17.4858 19.6789 17.2373 19.7974 16.9725 19.8113C16.7076 19.8252 16.4481 19.7333 16.251 19.5558C16.0539 19.3784 15.9354 19.1299 15.9215 18.865L15.8692 17.8664C15.8553 17.6015 15.9472 17.342 16.1246 17.1449C16.3021 16.9478 16.5506 16.8293 16.8155 16.8154C18.4669 16.7289 19.7525 15.535 19.6805 14.1618C19.6085 12.7887 18.2053 11.7357 16.5538 11.8223C14.9023 11.9088 13.6168 13.1027 13.6887 14.4759L13.7149 14.9752C13.7288 15.24 13.6369 15.4995 13.4594 15.6966C13.2819 15.8937 13.0335 16.0123 12.7686 16.0261C12.5037 16.04 12.2442 15.9481 12.0471 15.7707C11.85 15.5932 11.7315 15.3447 11.7176 15.0798L11.6915 14.5805C11.5616 12.1027 13.6954 9.96933 16.4491 9.82502C19.2028 9.6807 21.5479 11.5793 21.6778 14.0572C21.7915 16.2267 20.1678 18.133 17.914 18.6705ZM18.6536 23.228C18.6691 23.5243 18.5964 23.8185 18.4447 24.0735C18.2931 24.3284 18.0692 24.5327 17.8014 24.6604C17.5336 24.7881 17.234 24.8336 16.9404 24.791C16.6468 24.7484 16.3724 24.6197 16.1519 24.4212C15.9315 24.2227 15.7748 23.9633 15.7018 23.6757C15.6288 23.3882 15.6426 23.0855 15.7417 22.8058C15.8407 22.5262 16.0204 22.2821 16.2582 22.1046C16.4959 21.9271 16.7809 21.8241 17.0771 21.8086C17.4744 21.7878 17.8637 21.9256 18.1593 22.1918C18.455 22.458 18.6328 22.8307 18.6536 23.228Z"
        fill="#EB4C79"
      />
    </g>
    <defs>
      <clipPath id="clip0_622_2424">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(0 1.6748) rotate(-3)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>
